import config from './config'
export default {
	add: {
		en: 'Add',
		es: 'Agregar'
	},
	edit: {
		en: 'Edit',
		es: 'Editar'
	},
	save: {
		en: 'Save',
		es: 'Guardar'
	},
	delete: {
		en: 'Delete',
		es: 'Eliminar'
	},
	ok: {
		en: 'Ok',
		es: 'Ok'
	},
	close: {
		en: 'Close',
		es: 'Cancelar'
	},
	search: {
		en: 'Search',
		es: 'Buscar'
	},
	back: {
		en: 'Back',
		es: 'Atrás'
	},

	status: {
		en: 'Status',
		es: 'Estado'
	},
	all: {
		en: 'All',
		es: 'Todo'
	},

	'confirm-delete': {
		en: 'Confirm delete',
		es: 'Confirmar eliminación'
	},
	'are-you-sure-you-want-to-$': {
		en: 'Are you sure you want to {message}',
		es: '¿Está seguro de que quiere {message}?'
	},
	'the-entry': {
		en: 'the entry?',
		es: 'la entrada?'
	},
	'the-item': {
		en: 'the item?',
		es: 'el artículo?'
	},

	loading: {
		en: 'Loading',
		es: 'Cargando'
	},

	materials: {
		en: {
			primary: 'Primary',
			secondary: 'Secondary',
			trips: 'Trips',
			open: 'Open',
			yellow: 'Yellow',
			seeds: 'Seeds',
			crush: 'Crush'
		},
		es: {
			primary: 'Primario',
			secondary: 'Secundario',
			trips: 'Viajes',
			open: 'Abierto',
			yellow: 'Amarillo',
			seeds: 'Semillas',
			crush: 'Triturar'
		}
	},
	types: {
		en: {
			main: 'Main',
			sub: 'Sub'
		},
		es: {
			main: 'Principal',
			sub: 'Sub'
		}
	},

	headers: {
		en: {
			date: 'Date',
			provider: 'Provider',
			weight: 'Weight',
			'px-cal': 'P. X. Cal.',
			density: 'Density',
			item: 'Item',
			'purchase-cost': 'Purchase cost',
			'cf-cost': 'C&F Cost',
			'sale-price': 'Sale price',
			'total-cost': 'Total cost',
			utility: 'Utility',
			'entry-no': 'Entry no.',
			owner: 'Owner',
			no: 'No.',
			contract: 'Contract',
			client: 'Client',
			country: 'Country',
			completion: 'Completion',
			'sale-offer': 'Sale / Offer',
			in: 'In',
			out: 'Out',
			account: 'Account',
			lot: 'Lot',
			note: 'Note',
			'remaining-qty': 'Remaining Qty',
			total: 'Total',
			'total-price': 'Total price',
			'average-price': 'Average price',
			price: 'Price',
			notes: 'Notes',
			user: 'User',
			mix: 'Mix',
			name: 'Name',
			'start-date': 'Start date',
			'end-date': 'End date',
			'raw-cardamom-weight': `${config['raw-cardamom-weight'].en}`,
			quantity: 'Quantity',
			'deviation-percentage': 'Deviation',
			'total-weight': 'Total weight',
			'average-percentages-of-previous-purchases': 'Pervious purchases (avg)',
			status: 'Status'
		},
		es: {
			date: 'Fecha',
			provider: 'Proveedor',
			weight: 'Peso',
			'px-cal': 'P. X. Cal.',
			density: 'Densidad',
			item: 'Artículo',
			'purchase-cost': 'Costo de compra',
			'cf-cost': 'Costo C&F',
			'sale-price': 'Precio de venta',
			'total-cost': 'Costo total',
			utility: 'Utilidad',
			'entry-no': 'Entrada No.',
			owner: 'Propietario',
			no: 'No.',
			contract: 'Contrato',
			client: 'Cliente',
			country: 'País',
			completion: 'Finalización',
			'sale-offer': 'Venta / Oferta',
			in: 'Entrada',
			out: 'Salida',
			account: 'Cuenta',
			lot: 'Lote',
			note: 'Nota',
			'remaining-qty': 'Cantidad restante',
			total: 'Total',
			'total-price': 'Valor del lote',
			'average-price': 'Precio promedio',
			price: 'Precio',
			notes: 'Notas',
			user: 'Usuario',
			mix: 'Mezcla',
			name: 'Nombre',
			'start-date': 'Fecha de inicio',
			'end-date': 'Fecha final',
			'raw-cardamom-weight': `${config['raw-cardamom-weight'].es}`,
			quantity: 'Cantidad',
			'deviation-percentage': 'Desviación',
			'total-weight': 'Peso total',
			'average-percentages-of-previous-purchases': 'Compras anteriores (promedio)',
			status: 'Estado'
		}
	},

	inputs: {
		en: {
			username: 'Username',
			password: 'Password',
			'confirm-password': 'Confirm password',
			provider: 'Provider',
			date: 'Date',
			'entry-no': 'Entry no.',
			weight: 'Weight',
			density: 'Density',
			'exchange-rate': 'Exchange rate',
			'expenses-cf': 'C&F Expenses',
			'tax-percent': 'Tax percent',
			'px-cal': 'P. X. Cal.',
			'sale-offer': 'Sale / Offer',
			client: 'Client',
			price: 'Price',
			'contract-date': 'Contract date',
			'contract-no': 'Contract No',
			'delivery-date': 'Delivery date',
			item: 'Item',
			account: 'Account',
			'account-name': 'Account name',
			'item-name': 'Item name',
			'automatic-or-manual-no': 'Automatic or manual No.',
			type: 'Type',
			'parent-account': 'Parent account',
			'parent-item': 'Parent item',
			country: 'Country',
			notes: 'Notes',
			'is-mix': 'Is mix',
			'role-name': 'Role name',
			'from-date': 'From date',
			'to-date': 'To date',
			lot: 'Lot',
			owner: 'Owner',
			'item-to-purchase-from': 'Item to purchase from',
			income: 'Income',
			quality: 'Quality',
			'qq-net-weight': 'QQ net weight',
			'total-price': 'Total price',
			'special-invoice': 'Special invoice',
			'credit-note': 'Credit note',
			'paco-reference': 'Paco reference',
			no: 'No.',
			'owner-tree': 'Owner tree',
			'providers-tree': 'Providers tree',
			'customers-tree': 'Customers tree',
			detachment: 'Detachment',
			'raw-cardamom-item': `${config['raw-cardamom-item'].en}`,
			'cardamom-root': `${config['cardamom-root'].en}`,
			'crush-item': 'Crush item',
			'seeds-item': 'Seeds item',
			'wanted-weight': 'Wanted weight',
			name: 'Name',
			'start-date': 'Start date',
			'end-date': 'End date',
			'is-commercial': 'is commercial',
			'deviation-percentage': 'Deviation',
			humidity: 'Humidity',
			large: 'Large',
			medium: 'Medium',
			little: 'Little',
			mature: 'Mature',
			moldy: 'Moldy',
			broken: 'Broken',
			leaves: 'Leaves',
			colpila: 'Suwaiqat',
			'con-collila': 'Small branches',
			verde: 'Green',
			'exclude-from-statistics': 'Exclude from statistics',
			'weight-display': 'Weight Display',
			'price-display': 'Price display'
		},
		es: {
			username: 'Nombre de usuario',
			password: 'Contraseña',
			'confirm-password': 'Confirmar contraseña',
			provider: 'Proveedor',
			date: 'Fecha',
			'entry-no': 'No. de entrada',
			weight: 'Peso',
			density: 'Densidad',
			'exchange-rate': 'Tipo de cambio',
			'expenses-cf': 'Gastos C&F',
			'tax-percent': 'Porcentaje de impuesto',
			'px-cal': 'P. X. Cal.',
			'sale-offer': 'Venta / Oferta',
			client: 'Cliente',
			price: 'Precio',
			'contract-date': 'Fecha de contrato',
			'contract-no': 'No. de contrato',
			'delivery-date': 'Fecha de entrega',
			item: 'Artículo',
			account: 'Cuenta',
			'account-name': 'Nombre de la cuenta',
			'item-name': 'Nombre del artículo',
			'automatic-or-manual-no': 'No. automático o manual',
			type: 'Tipo',
			'parent-account': 'Cuenta principal',
			'parent-item': 'Artículo principal',
			country: 'País',
			notes: 'Notas',
			'is-mix': 'Es mezcla',
			'role-name': 'Nombre del rol',
			'from-date': 'Desde la fecha',
			'to-date': 'Hasta la fecha',
			lot: 'Lote',
			owner: 'Propietario',
			'item-to-purchase-from': 'Artículo para comprar de',
			income: 'Ingreso',
			quality: 'Calidad',
			'qq-net-weight': 'Peso neto QQ',
			'total-price': 'Valor del lote',
			'special-invoice': 'Factura especial',
			'credit-note': 'Nota de crédito',
			'paco-reference': 'Referencia Pago',
			no: 'No.',
			'owner-tree': 'Árbol de propietario',
			'providers-tree': 'Árbol de proveedores',
			'customers-tree': 'Árbol de clientes',
			detachment: 'Desprendimiento',
			'raw-cardamom-item': `${config['raw-cardamom-item'].es}`,
			'cardamom-root': `${config['cardamom-root'].es}`,
			'crush-item': 'Artículo triturado',
			'seeds-item': 'Artículo de semillas',
			'wanted-weight': 'Aranan kilo',
			name: 'Nombre',
			'start-date': 'Fecha de inicio',
			'end-date': 'Fecha final',
			'is-commercial': 'es comercial',
			'deviation-percentage': 'Desviación',
			humidity: 'Humedad',
			large: 'Grande',
			medium: 'Mediano',
			little: 'Pequeño',
			mature: 'Maduro',
			moldy: 'Mohoso',
			broken: 'Quebrado',
			leaves: 'Hojas',
			colpila: 'Colpila',
			'con-collila': 'Con_Collila',
			verde: 'Verde',
			'exclude-from-statistics': 'Excluir de las estadísticas',
			'weight-display': 'Pantalla de Peso',
			'price-display': 'Pantalla de Precio'
		}
	},

	tooltips: {
		en: {
			'item-statement': 'Item statement',
			'purchase-simulation': 'Offer simulation'
		},
		es: {
			'item-statement': 'Estado del artículo',
			'purchase-simulation': 'Oferta simulación'
		}
	},

	messages: {
		en: {
			'select-Item-to-purchase': 'Select Item to purchase',
			'deleted-successfully': 'Delete operation succeeded',
			'purchase-added': 'Purchase is added successfully',
			'purchase-edited': 'Purchase is edited successfully',
			'purchase-state-updated': 'Purchase state is updated successfully',
			'experimental-simulation-saved': 'Experimental simulation is saved',
			'material-simulation-saved': 'Material simulation is saved',
			'contract-added': 'Contract is added successfully',
			'contract-edited': 'Contract is edited successfully',
			'fiscal-year-added': 'Fiscal year is added successfully',
			'fiscal-year-edited': 'Fiscal year is edited successfully',
			'fiscal-year-active-updated': 'Acvtive fiscal year is updated successfully',
			'no-contract': 'No contract with this No.',
			'received-successfully': 'Receive operation succeeded',
			'mix-items-required': 'Mix items are NOT specified',
			'check-your-connection': 'Please, check your internet connection'
		},
		es: {
			'select-Item-to-purchase': 'Seleccionar artículo para comprar',
			'deleted-successfully': 'La operación de eliminación se ha realizado correctamente',
			'purchase-added': 'La compra se ha añadido con éxito',
			'purchase-edited': 'La compra se ha editado con éxito',
			'purchase-state-updated': 'El estado de la compra se ha actualizado con éxito',
			'experimental-simulation': 'Se guarda la simulación experimental',
			'material-simulation-saved': 'El material experimental se guarda',
			'contract-added': 'El contrato se ha añadido con éxito',
			'contract-edited': 'El contrato se ha editado con éxito',
			'fiscal-year-added': 'El año fiscal se agrega con éxito',
			'fiscal-year-edited': 'Año fiscal se edita con éxito',
			'fiscal-year-active-updated': 'El año fiscal activo se actualiza con éxito',
			'no-contract': 'No hay contrato con este número',
			'received-successfully': 'Operación de recepción exitosa',
			'mix-items-required': 'Los elementos de mezcla no se especifican',
			'check-your-connection': 'Por favor, verifique su conexión a Internet'
		}
	},

	components: {
		en: {
			'change-password': 'Change password',
			productions: 'Productions',
			warehouse: 'Warehouse',
			simulations: 'Simulations',
			settings: 'Settings',
			home: 'Home'
		},
		es: {
			'change-password': 'Cambiar contraseña',
			productions: 'Producciones',
			warehouse: 'Almacén',
			simulations: 'Simulaciones',
			settings: 'Configuraciones',
			home: 'Inicio'
		}
	},

	'cardamom-in-the-detachment': {
		en: `${config['cardamom-in-the-detachment'].en}`,
		es: `${config['cardamom-in-the-detachment'].es}`
	},
	'total-in': {
		en: 'Total input quantity ',
		es: 'Total income'
	},
	'total-out': {
		en: 'Total ouput quantity',
		es: 'Salida Total'
	},
	'remaining-quantity': {
		en: 'Remaining quantity',
		es: 'Cantidad restante'
	},
	
	'confirm-close': {
		en: 'Confirm close',
		es: 'Confirmar cierre'
	},

	compare: {
		en: 'Compare',
		es: 'Comparar'
	}
}